// extracted by mini-css-extract-plugin
export default {"page":"CZ-z","cartModal":"DZ-z","checkout":"EZ-z","placeholder":"FZ-z","account":"GZ-z"};